import { Injectable } from '@angular/core';
import { GenericBaseService } from './generic-base.service';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { ApiVersion, UrlService } from './url.service';
import { CustomerOrganizationBaseModel } from '../models/customer-organization-base.model';
import { Observable } from 'rxjs/Observable';
import { Url } from '../constants/url';
import { PageConfiguration } from '../models/page-configuration.model';

@Injectable({
  providedIn: 'root'
})
export class CRMService extends GenericBaseService {

  constructor(
    protected httpClient: HttpClient,
    protected toastrService: ToastrService,
    protected url: UrlService
  ) {
    super('CRM', httpClient, toastrService, url, ApiVersion.v2);
  }

  getOrganizationById(organizationId: string): Observable<CustomerOrganizationBaseModel> {
    return this.get<CustomerOrganizationBaseModel>(
      Url.CrmOrganizations,
      { OrganizationId: organizationId });
  }

  getOrganizations(pageConfiguration: PageConfiguration, filter: any = null): Observable<CustomerOrganizationBaseModel[]> {
    return this.getListPaginated<CustomerOrganizationBaseModel>(
      Url.CrmOrganizations,
      pageConfiguration,
      filter
    );
  }
}
